// 都道府県名 ↔ ISO コード変換
// データは destination-master-store 経由で DB から取得します
// ISO コードは SORT_ORDER から計算（1→JP01 … 47→JP47）
import { useDestinationMasterStore } from "@/store/destination-master-store.js";

/**
 * 都道府県名 → ISO コード（JP01-JP47）
 * @param {string} prefectureName
 * @returns {string|null}
 */
export function getISOCode(prefectureName) {
  if (!prefectureName) return null;
  const store = useDestinationMasterStore();
  return store.prefectureToIsoCode[prefectureName] || null;
}

/**
 * ISO コード → 都道府県名（短縮形）
 * @param {string} isoCode - "JP01"–"JP47"
 * @returns {string|null}
 */
export function getPrefectureName(isoCode) {
  if (!isoCode) return null;
  const store = useDestinationMasterStore();
  return store.isoCodeToPrefecture[isoCode] || null;
}
